module.exports = __webpack_public_path__ + "img/close-icon.d08df99d.svg";